import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap, share, finalize } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NewRequestService {
  apiUrl = environment.apiUrl;
  _addNewBrokerRequest = this.apiUrl + '/addNewBrokerRequest';
  _searchBrokerRequest = this.apiUrl + '/searchBrokerRequests';
  _updateBrokerRequest = this.apiUrl + '/updateBrokerRequest';
  _deleteRequest = this.apiUrl + '/archiveRequest'
  _getBrokerDetails = this.apiUrl + '/getBrokerDetailsById'
  getallEvents = this.apiUrl + '/getEvents';
  getBrokerRequestCompanies = this.apiUrl + '/getBrokerRequestCompanies';
  _indicativeQuote = this.apiUrl + '/createIndicativeQuote';
  _brokerQuote = this.apiUrl + '/createBrokerQuote';
  _bindQuote = this.apiUrl + '/bindQuote';
  _checkCapacity = this.apiUrl + '/getBinderCapacity';
  _requestCustomisedPrice = this.apiUrl + '/requestCustomisedPrice';
  _getSupportedCountry = this.apiUrl + '/getSupportedCountry';
  _getUsStatesData  = this.apiUrl + '/getUsStatesData';
  _restoreRequest = this.apiUrl + '/restoreRequest';
  _regenerateRequest = this.apiUrl + '/regenerateRequest';
  _getSubTypes = this.apiUrl + '/getSubTypes';
  _getPremiumStructure = this.apiUrl + '/getPremiumAmount';
  _downloadPolicy = this.apiUrl + '/downloadBrokerPolicy';
  _getHistoricEventsData = this.apiUrl + '/getHistoricEventsData';
  _getAgentsData = this.apiUrl + '/getCalculationAgents';
  _getBrokerClients = this.apiUrl + '/getBrokerClients';
  _getBrokerClientDetail = this.apiUrl + '/getBrokerClientDetail';
  _addBrokerClient = this.apiUrl + '/addBrokerClient ';
  _updateBrokerClient = this.apiUrl + "/updateBrokerClient" 
  _getBrokerRequestInfo = this.apiUrl + "/getBrokerRequestInfo";
  _getInsurerClients = this.apiUrl + '/getInsurerClients';
  _getInsurerClientDetail = this.apiUrl + '/getInsurerClientDetail';
  _addInsurerClient = this.apiUrl + '/addInsurerClient';
  _updateInsurerClient = this.apiUrl + '/updateInsurerClient';
  _archiveBrokerClient = this.apiUrl + '/archiveBrokerClient'

  token: any;
  header: any;
  _checkReservations = this.apiUrl + '/checkReservations';
  cache: any;
  cachedObservable: any;

  constructor(
    private http: HttpClient
  ) { }

  newRequest(data: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._addNewBrokerRequest, data, { headers: this.header });
  }

  getSubTypes() {
    return this.http.get(this._getSubTypes);
  }

  searchBrokerRequest(id: any, data: any, page: number, pageSize: number) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
  
    const url = `${this._searchBrokerRequest}/${id}?page=${page}&pageSize=${pageSize}`;

    return this.http.post(url, data, { headers: this.header });
  }

  // Builds a query string from a plain options object, dropping empty values.
  private toQueryString(options: { [key: string]: any }): string {
    const params = Object.keys(options || {})
      .filter(key => options[key] !== undefined && options[key] !== null && options[key] !== '')
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(options[key])}`);
    return params.length ? '?' + params.join('&') : '';
  }

  updateBrokerRequest(data: any, id: any, mode : any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.patch(this._updateBrokerRequest + '/' + id + '/' + mode, data, { headers: this.header });
  }

  getEvents() {
    let observable: Observable<any>;
    if (this.cache) {
      observable = of(this.cache);
    }

    else if (this.cachedObservable) {
      observable = this.cachedObservable;
    }
    else {
      this.cachedObservable = this.http.get(this.getallEvents).pipe(
        tap(res => this.cache = res),
        share(),
        finalize(() => this.cachedObservable = null)
      );
      observable = this.cachedObservable;
    }
    return observable;
  }

  getCompanies(id) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.get(this.getBrokerRequestCompanies + '/' + id, { headers: this.header });
  }

  getBrokerDetails(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.get(this._getBrokerDetails + '/' + id, { headers: this.header })
  }

  deleteBrokerRequest(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.patch(this._deleteRequest + '/' + id, {}, { headers: this.header });
  }

  regenerateBrokerRequest(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._regenerateRequest + '/' + id, {}, { headers: this.header });
  }

  restoreRequest(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.patch(this._restoreRequest + '/' + id, {}, { headers: this.header });
  }

  indicativeQuote(data: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._indicativeQuote, data, { headers: this.header });
  }

  brokerQuote(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._brokerQuote + '/' + id, {}, { headers: this.header });
  }

  bindQuote(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._bindQuote + '/' + id, {}, { headers: this.header });
  }

  checkCapacity(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._checkCapacity + '/' + id, {}, { headers: this.header });
  }

  requestCustomisedPrice(data: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._requestCustomisedPrice, data, { headers: this.header });
  }

  getSupportedCountry() {
    return this.http.get(this._getSupportedCountry);
  }
  
  getUsStatesData(){
    return this.http.get(this._getUsStatesData);
  }

  getPrice(data) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._getPremiumStructure, data, { headers: this.header })
  }

  downloadPolicyData(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._downloadPolicy + '/' + id, {}, { headers: this.header,  responseType: 'blob' });
  }

  getHistoricEvents(data: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._getHistoricEventsData, data, { headers: this.header });
  }

  getAgentsData() {
    return this.http.get(this._getAgentsData);
  }

  // With no `options`, returns the full unpaginated client list (used by
  // client pickers elsewhere in the app). Pass `page`/`pageSize` (plus the
  // optional filters) to get the paginated/filtered response used by the
  // Clients page grid — same page/pageSize convention as searchBrokerRequest.
  getBrokerClient(id: any, options?: {
    page?: number; pageSize?: number; search?: string; country?: string;
    subdivision?: string; hideArchived?: boolean; policiesExpiresIn28Days?: boolean;
    clientDetailsId?: any;
  }) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    const url = this._getBrokerClients + '/' + id + this.toQueryString(options);
    return this.http.get(url, { headers: this.header })
  }

  // Single-record lookup for the client-details page, instead of fetching
  // the whole broker client list just to pick one record out by id.
  getBrokerClientDetail(clientId: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.get(this._getBrokerClientDetail + '/' + clientId, { headers: this.header });
  }

  addBrokerClient(clientData) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._addBrokerClient, clientData, { headers: this.header });
  }

  checkReservations(id: any){
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._checkReservations + '/' + id, {}, { headers: this.header });
  }

  updateBrokerClient(id:any, data:any){
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.patch(this._updateBrokerClient + '/' + id, data, { headers: this.header });
  }

  getQuoteReferralData(id:any , id2:any){
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.get(this._getBrokerRequestInfo + '/' + id+ '/' + id2, { headers: this.header })
  }

  // Same paginated/full-list duality as getBrokerClient above.
  getInsurerClient(id: any, options?: {
    page?: number; pageSize?: number; search?: string; country?: string;
    subdivision?: string; policiesExpiresIn28Days?: boolean; insurerDetailsId?: any;
  }) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    const url = this._getInsurerClients + '/' + id + this.toQueryString(options);
    return this.http.get(url, { headers: this.header })
  }

  // Single-record lookup for the client-details page, instead of fetching
  // the whole insurer client list just to pick one record out by id.
  getInsurerClientDetail(insurerId: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.get(this._getInsurerClientDetail + '/' + insurerId, { headers: this.header });
  }

  addInsurerClient(data : any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._addInsurerClient, data, { headers: this.header })
  }

  updateInsurerClient(id:any, data:any){
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.patch(this._updateInsurerClient + '/' + id, data, { headers: this.header });
  }

  archiveClient(id, data){
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.patch(this._archiveBrokerClient + '/' + id, data, { headers: this.header });
  }
}
